const Config = {
    CanvasTag : "ViewPort",
    Camera : {
        Interpolation : 40,
        ZoomIncrement : .1,
    },
    Limit: 3,
    Default: {
        Text : {
            Alignment : `left`,
            Color : `#000000`,
            FontSmall: '12px Arial',
            FontLarge: '15px Arial',
        },
    }
}

export default Config;